export enum TemplatesSection {
    EVALUATION = 'EVALUATION',
    LEAD_SUMMARY = 'LEAD_SUMMARY',
    REPORTS = 'REPORTS'
}

export const DEFAULT_TEMPLATE_LEAD_SUMMARY = 'defaultSummary';
